
import { defineComponent } from "vue";
import { getConfigData } from "@/provide/wxConfig";
export default defineComponent({
  name: "App",
});
getConfigData();
